import React from 'react';

import EntityForm from 'components/EntityPage/EntityForm';
import CONSTANTS from 'utils/constants';
import userSchema from '../schema';

const Satellite = ({
  isEditing,
  isProfile,
  isCreating,
  entity,
  entityInfos,
  options,
  onSubmitHandler,
}) => {
  const entityInfosWithScreen = {
    ...entityInfos,
    i18nScreenName: CONSTANTS.ENTITIES.SATELLITES.i18nFormScreenName,
  };

  return (
    <EntityForm
      isProfile={isProfile}
      isEditing={isEditing}
      isCreating={isCreating}
      entity={entity}
      entityInfos={entityInfosWithScreen}
      options={options}
      onSubmitHandler={onSubmitHandler}
      schema={userSchema}
    />
  );
};

export default Satellite;
